'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppBar = require('./AppBar');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AppBar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/AppBar/index.js
// module id = 3030
// module chunks = 0